// extracted by mini-css-extract-plugin
export default {"con":"index_con_g22OA","tit":"index_tit_jEMOY","list":"index_list_eGLfN","numIcon":"index_numIcon_MXVrw","red":"index_red_U1FSs"};